module.exports = __webpack_public_path__ + "static/media/top-bg.ee59308f.png";